import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../../../common/constants';
export const getSchedulesEndpoint = () => {
  return fetch(`${urls.schedules.onCalls.url()}`);
};